// @flow

export default ({
  ...extra
}: jsx$HTMLElement): ExactReactElement_DEPRECATED<'svg'> => ( // $FlowFixMe[cannot-spread-inexact]
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...extra}>
    <path
      d="M7.52378 0C8.15496 0 8.66663 0.511675 8.66663 1.14286L8.66663 10.2857C8.66663 10.9169 8.15496 11.4286 7.52378 11.4286C6.89259 11.4286 6.38092 10.9169 6.38092 10.2857L6.38092 1.14286C6.38092 0.511674 6.8926 0 7.52378 0Z"
      fill="#EE7620"
    />
    <path
      d="M9.04762 14.4761C9.04762 15.3177 8.36539 15.9999 7.52381 15.9999C6.68223 15.9999 6 15.3177 6 14.4761C6 13.6345 6.68223 12.9523 7.52381 12.9523C8.36539 12.9523 9.04762 13.6345 9.04762 14.4761Z"
      fill="#EE7620"
    />
  </svg>
);
